import { DiscountPrefix } from "@cgc/constants";

export function benefitsRenderAllowed(
  code: string | undefined | null,
): boolean {
  return code && !code.startsWith(DiscountPrefix.SIP);
}
